export default "<abw-page-builder-datasources [model]=\"model\"></abw-page-builder-datasources>";